<template>
  <div v-loading="loading" class="follow-context">
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <h4>原跟进记录</h4><p class="content">{{ message.sourceContent }}</p>
    <el-button v-if="message.sourceUserId" type="text" @click="replyTo(message.sourceUserId)">回复跟进</el-button>
    <article v-for="row in rows" :key="row.id" :ref="`reply-${row.id}`" :class="{ focused: String(row.id) === String(message.recordId) && message.sourceType === 'followReply' }">
      <strong>{{ row.replyUserName || row.createByName || '同事' }}</strong><span> {{ row.createTime }}</span>
      <p class="content">{{ row.plainContent || row.replyContent }}</p>
      <el-button type="text" @click="replyTo(row.createBy)">回复</el-button>
    </article>
    <div v-if="receiver" class="reply-editor">
      <p>回复{{ receiverName }}</p>
      <el-input v-model="content" type="textarea" :rows="3" :maxlength="2000" show-word-limit placeholder="请输入回复内容" />
      <el-button type="primary" :loading="saving" @click="submit">发送回复</el-button>
      <el-button @click="receiver = null">取消</el-button>
    </div>
  </div>
</template>
<script>
import { queryFollowReplyList, createFollowReply } from '@/api/crm/follow'
export default {
  props: { message: { type: Object, required: true } },
  data: () => ({ rows: [], loading: false, saving: false, error: '', receiver: null, receiverName: '', content: '' }),
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true; this.error = ''
      try {
        const response = await queryFollowReplyList({ followId: this.message.sourceId })
        this.rows = Array.isArray(response) ? response : (response.data || response.rows || [])
        this.$emit('loaded', this.rows)
        this.$nextTick(() => {
          const nodes = this.$refs[`reply-${this.message.recordId}`]
          if (nodes && nodes[0]) nodes[0].scrollIntoView({ block: 'center', behavior: 'smooth' })
        })
      } catch (err) { this.error = err.message || '跟进回复加载失败，请重试' }
      finally { this.loading = false }
    },
    replyTo(userId) {
      this.receiver = userId; this.content = ''
      const row = this.rows.find(row => String(row.createBy) === String(userId))
      this.receiverName = row ? (row.replyUserName || '该同事') : '跟进发起人'
    },
    async submit() {
      if (this.saving || !this.receiver || !this.content.trim()) return
      this.saving = true
      try {
        await createFollowReply({ followId: this.message.sourceId, replyTargetUserId: this.receiver, replyContent: this.content.trim(), contentType: 1 })
        this.receiver = null; this.content = ''; this.$message.success('回复成功'); await this.load()
      } catch (err) { this.error = err.message || '回复失败' }
      finally { this.saving = false }
    }
  }
}
</script>
<style scoped>
.content { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.8; }
article { padding: 16px; border-bottom: 1px solid #eee; }
article span { color: #909399; }
.focused { background: #ecf5ff; border-left: 3px solid #409eff; }
.reply-editor { margin: 16px 0; }
.reply-editor .el-button { margin-top: 12px; }
</style>
